import { styled, MuiAlert, Box } from '@bluedolphin/ui';

import { shouldForwardProp } from '../../../util/misc';

export const StyledMuiAlert = styled(MuiAlert, {
    shouldForwardProp: shouldForwardProp('hasNavBar'),
})<{ hasNavBar: boolean }>(({ hasNavBar }) => ({
    position: 'absolute',
    height: 'fit-content',
    zIndex: 99999999999,
    top: hasNavBar ? 76 : 12,
    borderRadius: 2,
}));

export const StyledBox = styled(Box)(() => ({
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    zIndex: 9999999999,
    top: 0,
    left: 0,
    background: 'rgba(255, 255, 255, 0.5)',
    display: 'flex',
    justifyContent: 'center',
}));
